export default {
  name: 'TdProgress',
  props: {
    type: {
      type: String,
      default: 'line',
      validator: val => ['line', 'circle'].includes(val)
    },
    color: String,
    height: Number,
    outerColor: String,
    textVisible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, String],
      default: 0
    },
    width: {
      type: Number,
      default: 120
    },
    strokeWidth: {
      type: Number,
      default: 6
    },
    linecap: {
      type: String,
      default: 'round'
    }
  },
  computed: {
    circleSize() {
      // 圆环大小
      return this.type === 'circle' ? {
        width: `${this.width}px`,
        height: `${this.height}px`
      } : {};
    },
    radius() {
      // 半径
      if (this.type === 'circle') {
        return this.width / 2 - this.strokeWidth;
      }
      return 0;
    },
    circleDistance() {
      // 圆环的位置
      const distance = this.radius + this.strokeWidth;
      return distance;
    },
    perimeter() {
      // 圆环周长
      return 2 * Math.PI * this.radius;
    },
    view() {
      // 视图大小
      const view = `0 0 ${this.width} ${this.width}`;
      return view;
    },
    circlePathStyle() {
      // 绘制圆环
      let color = this.color;
      if (this.value === 0) {
        color = 'transparent';
      }
      return {
        strokeDasharray: `${this.perimeter * (this.value / 100)}px, ${this.perimeter}px`,
        transform: 'rotate(-90deg)',
        stroke: color,
        transformOrigin: `${this.circleDistance}px ${this.circleDistance}px`,
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
      };
    }
  }
};